import React, { useEffect, useState } from 'react'
import { Button, FocusTrap, Group, Modal, Select, Stack, Text, TextInput } from "@mantine/core"
import { FieldFilter, FILTER, numberOperators, textOperators } from '../../../../../constants/filter-operators'
import { ColumnDef } from './ReviewMatchesTable/table-helpers'

type ApplyFilterModalProps = {
  opened: boolean
  onClose: () => void
  filters: FieldFilter[]
  filter?: ColumnDef
  setFilters: React.Dispatch<React.SetStateAction<FieldFilter[]>>
  setPage: React.Dispatch<React.SetStateAction<number>>
}

export const ApplyFilterModal = ({ opened, onClose, filter, filters, setFilters, setPage }: ApplyFilterModalProps) => {
  const [value, setValue] = useState('')
  const [operator, setOperator] = useState<FILTER>(FILTER.LIKE)

  const handleClose = () => {
    setValue('')
    setOperator(FILTER.LIKE)
    onClose()
  }

  useEffect(() => {
    if (filter?.type === 'number') setOperator(FILTER.GREATER_THAN_OR_EQUAL)
  }, [filter])

  useEffect(() => {
    const foundFilter = filters.find(f => f.sourceField === filter?.fieldCode)
    if (foundFilter) {
      setValue(foundFilter.value)
      setOperator(foundFilter.operator)
    }
    
  }, [filters, filter?.fieldCode])

  if (!filter) return

  const handleApply = () => {
    handleClose()
    setPage(1)
    setFilters(prev => {
      const alreadyAppliedFilter = filters.find(f => f.sourceField === filter.fieldCode)
      if (alreadyAppliedFilter) {
        return prev.map(prevFilter => {
          if (prevFilter.sourceField === filter.fieldCode) return ({ ...prevFilter, operator, value })
          return prevFilter
        })
      }
      return [...prev, { label: filter.label, sourceField: filter.fieldCode, operator, value, type: filter.type }]
    })
  }

  return (
    <Modal title='Apply Filter' opened={opened} onClose={handleClose} size='auto'>
      <FocusTrap active={true}>
        <Stack my='xl'>
          <Group wrap='nowrap' justify='center' mb='xl'>
            <Text size='lg'>{ filter.label }</Text>
            <Select
              size='lg'
              data={filter.type === 'text' ? textOperators : numberOperators}
              allowDeselect={false}
              value={operator}
              onChange={val => setOperator(val as FILTER)}
            />
            <TextInput
              size='lg'
              value={value}
              disabled={[FILTER.IS_NOT_NULL, FILTER.IS_NULL].includes(operator)}
              data-autofocus
              placeholder='Filter value'
              onChange={e => setValue(e.currentTarget.value)} 
              onKeyDown={e => {
                if (e.key === 'Enter' && !!value.length) handleApply()
              }}
            />
          </Group>
          <Group justify='flex-end'>
            <Button size='lg' variant='outline' onClick={handleClose}>Cancel</Button>
            <Button size='lg' onClick={handleApply}>
              Apply
            </Button>
          </Group>
        </Stack>
      </FocusTrap>
    </Modal>
  )
}
